/*
  Project: Starter Test
  Author: Michał Strześniewski
 */

import inputs from './modules/inputs';
import slider from './modules/slider';
import links from './modules/links';
import mobilemenu from './modules/mobilemenu';
import postSlider from './modules/postSlider';

inputs();
mobilemenu();
slider();
links();
postSlider();


// WEBPACK FOOTER //
// ./wp/wp-content/themes/factory-logistic-chisel/src/scripts/app.js